var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "#FFF5E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 42.3625C26 43.1316 26.3055 43.8692 26.8494 44.4131C27.3932 44.957 28.1309 45.2625 28.9 45.2625C29.6691 45.2625 30.4068 44.957 30.9506 44.4131C31.4945 43.8692 31.8 43.1316 31.8 42.3625C31.8 41.5934 31.4945 40.8557 30.9506 40.3119C30.4068 39.768 29.6691 39.4625 28.9 39.4625C28.1309 39.4625 27.3932 39.768 26.8494 40.3119C26.3055 40.8557 26 41.5934 26 42.3625ZM27.45 34.75H30.35C30.5494 34.75 30.7125 34.5869 30.7125 34.3875V13.3625C30.7125 13.1631 30.5494 13 30.35 13H27.45C27.2506 13 27.0875 13.1631 27.0875 13.3625V34.3875C27.0875 34.5869 27.2506 34.75 27.45 34.75Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8e79f5aa04c175db64c206a540394f24.svg";
export { ForwardRef as ReactComponent };